<template>
    <el-dialog :visible.sync ="showNoticetion" @close="handleCloseDialog" :close-on-click-modal="false">

        <el-form ref="detailsObject" :model="detailsObject" label-width="80px">

            <h2 class="custom-title">{{ detailsObject.noticeTitle  }}</h2>
            
            <el-divider></el-divider>

            <div style="display:flex; height:60px; line-height:60px">
              <span style="width: 170px; font-size:18px">通知方：</span>
              <div style="font-size:18px">工程部</div>
            </div>

            <div style="display:flex; height:60px; line-height:60px">
              <span style="width: 170px; font-size:18px">相关项目：</span>
              <div style="font-size: 18px">
                {{ getSelectedProjectNames() }}
              </div>
            </div>

            <div style="display:flex; height:60px; line-height:60px">
              <span style="width: 170px ; font-size:18px">相关人员：</span>
              <div style="font-size: 18px">
                {{ getSelectUserNames() }}
              </div>
            </div>

            <div style="display:flex; ">
              <span style="width: 170px ; font-size:18px">公告详情：</span>
                 <mavon-editor
                    id="md-preview"
                    ref = "md"
                    :value="detailsObject.noticeMd"
                    style=" width:100%"
                    :subfield="false"
                    :toolbarsFlag="false"
                    defaultOpen="preview"
                 >
                 </mavon-editor>
            </div>

            <el-form-item style="margin-top:15px">
                <el-button type="primary" @click="handleNotedInfo(1)">已阅</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>


</template>

<script>
import { mapState } from 'vuex';
export default {
    name:'NoticeMessage',

    data(){
        return {

            detailsObject:{},

            // 项目集合
            projetItemsInfo:[],

            userListInfo:[]
        }
    },

    computed: {
        ...mapState(['userId', 'noticeStatus','readStatusInfo']),
        
        showNoticetion:{

            get() {
                //  1.noticeStatus 不等于0时，且showNoticetion为true时，进行展示，现在在加一个条件，当readStatusInfo 为0 时展示
                return this.noticeStatus !== 0 && this.$store.state.showNoticetion && this.$store.state.readStatusInfo == "0"
            },

            set(value) {
                this.$store.commit('setShowNoticetion', value)
            }
        }, 
    },

    created(){
        // 1.查询人员列表信息
        this.selectUserListInfo();

        // 2.查询项目列表信息
        this.selectProjectItemsList();

        // 3.查询当前人员是否存在具体的公告当中
        this.selectNoticeInfo()
    },

    methods:{
        handleCloseDialog(){
            this.$store.commit('setShowNoticetion', false)
        },
        
        // 详情查看时，对项目团队、人员信息进行处理
        getSelectedProjectNames(){

            if (!this.detailsObject.projectIdsList || !this.projetItemsInfo) return '全体项目'

           
            return this.detailsObject.projectIdsList.map(id =>{
                const project = this.projetItemsInfo.find(item => item.id === id)
                return project ? project.projectName : ''
            }) .filter(name => name) // 过滤无效值
            .join('，') // 中文逗号分隔
        },

        getSelectUserNames(){
            if (!this.detailsObject.userIdsList || !this.userListInfo) return '全体人员'

            return this.detailsObject.userIdsList.map(id =>{
                const userInfo = this.userListInfo.find(item => item.id === id)
                return userInfo ? userInfo.userName : ''
            }) .filter(name => name) // 过滤无效值
            .join('，') // 中文逗号分隔
        },


        // 1. 查询人员集合信息
        selectUserListInfo() {
            this.$axios.get("/selectUserListInfo").then((resp) => {
                if (resp.data.code === 200) {

                    // 初始化时设置完整数据
                    this.userListInfo = resp.data.data
                }
            });
        },

        // 2.查询项目列表
        selectProjectItemsList(){
            this.$axios.get("/selectProjectItemsList").then((resp) => {
                if (resp.data.code === 200) {
                    // 1.对查询的结果进行处理,将项目编号字符串调整为集合
                    this.projetItemsInfo = resp.data.data;

                    console.log('项目集合信息', this.projetItemsInfo)
                }
            });
        },


        // 3.查询公告信息
        selectNoticeInfo(){

            // 1.如果noticeStatus 为2, 那就说明是全体员工,就把userId参数置为空
            const noticeStatus = this.noticeStatus;

            if(noticeStatus === 2){

                const  userId = ''

                this.$axios.post('/selectNoticeInfo', {userId:userId}).then(response =>{
                    if(response && response.data.code === 200){
                        this.detailsObject = response.data.data;
                    }
                })
            }else {
                this.$axios.post('/selectNoticeInfo', {userId:this.userId}).then(response =>{
                    if(response && response.data.code === 200){
                        this.detailsObject = response.data.data;
                    }else {
                        this.detailsObject = {};
                    }
                })
            }
        },


        // 已经阅读状态值
        handleNotedInfo(){
            this.$axios.post('/updateReadStatusById', {userId:this.userId}).then(response =>{
                if(response && response.data.code === 200){
                 this.$store.commit('setShowNoticetion', false)
                }
            })
        }
    }
}

</script>

<style scoped>

</style>